module.exports = __webpack_public_path__ + "img/2.be783cf9.png";